export const environment = {
	production: false,
	apiUrl: 'http://keyskills-staging-frontend:3000/v1',
	showFeatureDev: false,
	frontEndUrl: 'https://staging.playskills.it'
};
